<template>
  <div>
    <b-alert show>This site is part of a site request.</b-alert>

    <div class="top-controls">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
        <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>
      </b-input-group>
    </div>

    <b-table striped
             :items="studentRequests"
             :fields="fields"
             :per-page="perPage"
             :current-page="currentPage"
             :filter="filter"
             @filtered="onFiltered"
             small>
      <template slot="status" slot-scope="data">
        {{ data.item.studentRequestStatus.name }}
      </template>
      <template slot="stage" slot-scope="data">
        {{ data.item.studentRequestStage.name }}
      </template>
      <template slot="createdDate" slot-scope="data">
        {{ data.item.createdDate | formatDate }}
      </template>
      <template slot="student" slot-scope="data">
        {{ data.item.user ? data.item.user.firstName : "" }} {{ data.item.user ? data.item.user.lastName : "" }}
      </template>
      <template slot="semester" slot-scope="data">
        {{ data.item.term ? data.item.term.description : "" }}
      </template>
      <template slot="view" slot-scope="data">
        <router-link :to="{ name: 'request', params: { requestId: data.item.studentRequestId } }">View</router-link>
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />

    <div v-if="userCanRequestContract() && contractCanBeRequested(studentRequests[0])">
      <b-alert show>
        By requesting a contract, a contract manager will be notified to review the site and create a contract if necessary. Once the contract manager has given approval, you will be notified to give a final approval. The student will be automatically associated with the opportunity and will be notified that their request has been fulfilled.
      </b-alert>
      <div class="align-right">
        <b-button class="request-button btn-primary" @click="requestContract(studentRequests[0])">Request Contract</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import studentRequestApi from "../../api/studentRequest";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      studentRequests: [],
      fields: [
        { key: "status" },
        { key: "stage" },
        { key: "createdDate" },
        { key: "student" },
        { key: "businessName" },
        { key: "semester" },
        { key: "view", label: "" }
      ],
      currentPage: 1,
      perPage: 10,
      filter: null,
      totalRows: 0
    };
  },

  props: {
    requests: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  watch: {
    requests: function() {
      this.totalRows = this.requests.length;
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    userCanRequestContract: function() {
      return _.find(this.user.userRoles, function(userRole) {
        return (
          userRole === "Placements.Admin" || userRole === "Placements.Advisor"
        );
      });
    },

    contractCanBeRequested: function(request) {
      if (
        request.studentRequestStatus.name === "Open" &&
        request.studentRequestStage.name === "Site Review"
      ) {
        return true;
      }
      return false;
    },

    requestContract: function(request) {
      var that = this;
      studentRequestApi
        .postStudentRequestSiteApproval(request)
        .then(function() {
          that.refreshRequest();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    refreshRequest: function() {
      var that = this;
      studentRequestApi
        .getStudentRequest(this.studentRequests[0].studentRequestId)
        .then(function(response) {
          // replace first request with response
          that.studentRequests.splice(0, 1, response.data);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },

  // when the widget is created, make a copy of the student requests and display those
  // this is because if a contract is requested, we will need to change the status of the request
  // and we need to avoid mutating props
  created() {
    this.studentRequests = this.requests;
  }
};
</script>

<style scoped>
table {
  font-size: 10pt;
}

.widget-body {
  font-size: 13px;
}

.align-right {
  text-align: right;
}

.top-controls {
  margin-bottom: 10px;
}

.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
  display: inline-flex;
}
</style>
